import BoldIcon from '@app/components/icons/bold';
import ClearFormatting from '@app/components/icons/clear-formatting';
import ItalicIcon from '@app/components/icons/italic';
import StrikethroughIcon from '@app/components/icons/strikethrough';
import UnderlineIcon from '@app/components/icons/underline';
import { T } from '@app/components/translation';

import { BOLD, CLEAR_FORMATTING, ITALIC, STRIKETHROUGH, UNDERLINE } from '../constants';
import { clearFormatting, toggleMark } from '../utils/mark-utils';

export const ACTIONS = [
  BOLD,
  ITALIC,
  UNDERLINE,
  STRIKETHROUGH,
  CLEAR_FORMATTING,
] as const;

export const TOOLBAR_ACTIONS = [
  {
    kind: BOLD,
    icon: (
      <BoldIcon
        height={24}
        width={24}
      />
    ),
    label: (
      <T
        _str="Bold"
        comment="Label for bold action"
      />
    ),
    action: toggleMark,
  },
  {
    kind: ITALIC,
    icon: (
      <ItalicIcon
        height={24}
        width={24}
      />
    ),
    label: (
      <T
        _str="Italic"
        comment="Label for italic action"
      />
    ),
    action: toggleMark,
  },
  {
    kind: UNDERLINE,
    icon: (
      <UnderlineIcon
        height={24}
        width={24}
      />
    ),
    label: (
      <T
        _str="Underline"
        comment="Label for underline action"
      />
    ),
    action: toggleMark,
  },
  {
    kind: STRIKETHROUGH,
    icon: (
      <StrikethroughIcon
        height={24}
        width={24}
      />
    ),
    label: (
      <T
        _str="Strikethrough"
        comment="Label for strikethrough action"
      />
    ),
    action: toggleMark,
  },
  {
    kind: CLEAR_FORMATTING,
    icon: (
      <ClearFormatting
        height={24}
        width={24}
      />
    ),
    label: (
      <T
        _str="Clear formatting"
        comment="Label for clear formatting action"
      />
    ),
    action: clearFormatting,
  },
];
